import { FancyBearMetadata } from "types";
import * as metadataApi from "api/metadataApi";
import useFetchPromise from "hooks/useFetchPromise";

const useFetchMetadata = (tokenId?: number) =>
  useFetchPromise<FancyBearMetadata, number>(
    metadataApi.fetchMetadata,
    tokenId
  );

export default useFetchMetadata;
